import { AppRoute } from "../router";
import { useEffect, useState } from "react";
import Header from "./header";
import { useLocation, useNavigate } from "react-router-dom";
import Modal from "react-modal";
import { useLoading } from "../libs/loadingContext";
import loadingCylindaLogo from "../assets/images/loading/cylinda-logo.png";
import { QuestionMarkCircleIcon } from "@heroicons/react/20/solid";

Modal.setAppElement("#root");

function Layout() {
  const [showQuestionMark, setShowQuestionMark] = useState(true);
  const location = useLocation();

  useEffect(() => {
    location.pathname === "/support"
      ? setShowQuestionMark(false)
      : setShowQuestionMark(true);
  }, [location.pathname]);

  let navigate = useNavigate();
  const { loading } = useLoading();
  return (
    <>
      <div className="container">
        <div className="main-page">
          {loading && (
            <div className="overlay">
              <div className="loader">
                <img src={loadingCylindaLogo} alt="loading" />
              </div>
            </div>
          )}
          <div className={`content ${location.pathname === "/" ? "home" : ""}`}>
            <Header />
            <AppRoute />
            {showQuestionMark && (
              <div className="support">
                <QuestionMarkCircleIcon
                  className="question"
                  style={{
                    width: 38 + "px",
                    height: 38 + "px",
                    color: "#f3a18c",
                  }}
                  onClick={() => navigate("/support")}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default Layout;
